import CommunityProfileTopicTag from './CommunityProfileTopicTag'

export default CommunityProfileTopicTag
export * from './CommunityProfileTopicTag'
